import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          fill="currentColor"
          d="m70.85 67.135 -26.317 -56a2 2 0 0 0 -1.81 -1.15h-2.72a1.995 1.995 0 0 0 -1.803 1.137l-0.005 0.012 -26.323 56a2 2 0 0 0 1.805 2.85h2.483a2 2 0 0 0 1.808 -1.14l0.005 -0.012 6.1 -13.008h34.504l6.177 13.017a2.003 2.003 0 0 0 1.808 1.143h2.48a2 2 0 0 0 1.805 -2.863l0.005 0.012zM26.995 49.503l14.36 -30.425 14.295 30.425z"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
